import { Link } from 'react-router-dom';

import {
  Button,
  ButtonElementTypes,
  ButtonSizeXL,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';

import { useTranslator } from '@picsart/rc/services/localization';
import { RelatedCategoriesTargetModel } from 'templates/types';
import { useCategoryStyles } from './styles';

export default function TemplatesRelatedCategory({
  uid,
  anchor,
  targetUrl,
}: RelatedCategoriesTargetModel) {
  const classes = useCategoryStyles();
  const translate = useTranslator();

  return (
    <li className={classes.root}>
      <Link to={targetUrl}>
        <Button
          key={uid}
          tag={ButtonElementTypes.Button}
          size={ButtonSizeXL}
          variant={ButtonVariants.Outline}
          skin={ButtonSkinSecondary}
          data-pulse-name={`Related category: ${anchor}`}
        >
          {translate(anchor)}
        </Button>
      </Link>
    </li>
  );
}
